module.exports = __webpack_public_path__ + "img/bg_personalcenter.b55cb3b2.jpg";